if (!customElements.get('sticky-price')) {
  class StickyPrice extends HTMLElement {
    constructor() {
      super();

      this.updateRef = this.update.bind(this);
    }

    update(event) {
      if (!event.detail.html) return;

      this.innerHTML = event.detail.html;
    }

    disconnectedCallback() {
      document.removeEventListener('exo-price-html-update', this.updateRef);
    }

    connectedCallback() {
      document.addEventListener('exo-price-html-update', this.updateRef);
    }
  }
  customElements.define('sticky-price', StickyPrice);
}
